<template>
  <div id="contenedor-editar-contrato-video">
    <v-form v-model="formularioValido" ref="formEditarContratoVideo">
      <v-card>
        <v-card-title class="secondary--text">
          Editar video
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <date-picker
              v-model="video.fecha"
              label="Fecha"
              cols="6"
              :md="$vuetify.breakpoint.mobile ? '12' : '6'"
              :rules="[mixReglas.requerido]"
            >
            </date-picker>
            <text-field
              cols="12"
              md="12"
              v-model="video.url"
              label="Url de Video"
              :rules="[mixReglas.requerido]"
            >
            </text-field>
            <span v-if="!mixValidarUrl" class="red--text ml-4">Url inválida.</span>
            <custom-text-area
              cols="12"
              v-model="video.descripcion"
              label="Descripcion (Opcional)"
              rows="3">
            </custom-text-area>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoVideo"
            :disabled="!formularioValido || enviandoFormulario || !mixValidarUrl"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratoVideos from './mixContratoVideos';
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarContratoInsumo',
  mixins: [mixContratoVideos],
  props: {
    contratoVideoEditar: {
      type: Object,
      requiered: true,
    },
  },
  components: {
    TextField,
    CustomButton,
    DatePicker,
    CustomTextArea,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      video: {
        fecha: this.contratoVideoEditar.fecha,
        url: this.contratoVideoEditar.url,
        descripcion: this.contratoVideoEditar.descripcion,

      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.formEditarContratoVideo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
